import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { AgendaRepository } from "../../../domain/repositories/agenda.repositories";

import { environment } from "../../../../environments/environment";
import { UserRoleDTO } from "../../../domain/use-cases/agenda/get-role.usecase";
import {
  AgendaItem,
  CreateWorkloadDto,
  CreateWorkloadResponse,
  GetAgendaResponse,
} from "./entities/agenda.model";

@Injectable()
export class AgendaRepositoryImpl extends AgendaRepository {
  private readonly endpoint = environment.apiUrl;

  constructor(private http: HttpClient) {
    super();
  }

  override retrieveAgenda(rinaId: string): Observable<AgendaItem[]> {
    return this.http
      .get<GetAgendaResponse>(`${this.endpoint}/sm/agenda`, {
        params: { rinaId },
      })
      .pipe(map((response) => response?.agenda));
  }
  override retrieveWorkspace(rinaId: string): Observable<AgendaItem[]> {
    return this.http
      .get<GetAgendaResponse>(`${this.endpoint}/sm/workspace`, {
        params: { rinaId },
      })
      .pipe(map((response) => response?.agenda));
  }
  override sendNotification(id: number): Observable<AgendaItem> {
    return this.http
      .put<any>(`${this.endpoint}/sm/agenda/${id}/displayed`, { id })
      .pipe(map((response) => response.agenda));
  }
  override createWorkloadDraft(
    workload: CreateWorkloadDto,
  ): Observable<CreateWorkloadResponse> {
    return this.http.post<CreateWorkloadResponse>(
      `${this.endpoint}/sm/agreement`,
      workload,
    );
  }

  override getUserRole(rinaId: string): Observable<UserRoleDTO> {
    return this.http.get<UserRoleDTO>(`${this.endpoint}/hr/userRole`, {
      params: { rinaId },
    });
  }
}
